module.exports = __webpack_public_path__ + "img/icon_2.c884e93c.png";